export const SHOW_HINT = 'SHOW_HINT';
export const SET_HINT_TYPE = 'SET_HINT_TYPE';
export const SET_HINT_CIRCLE = 'SET_HINT_CIRCLE';
export const SET_HINT_TEXT = 'SET_HINT_TEXT';
export const SET_HINT_BG_SIZE = 'SET_HINT_BG_SIZE';